<template>
  <section v-swiper:mainBanner="swiperOption" :class="swiperName">
    <ul class="swiper-wrapper">
      <li class="swiper-slide" :key="item.id" v-for="item in banners">
        <a :href="item.link" target="_blank">
          <img :src="item.url" :alt="item.alt"
        /></a>
        <!-- swiper-no-swiping -->
        <div v-if="item.description" :class="['b-description', `b` + item.id]">
          <h3 v-if="item.description.title">{{ item.description.title }}</h3>
          <div
            v-if="item.description.paragraph"
            v-html="item.description.paragraph"
          ></div>
          <a
            v-if="item.description.btnName"
            :href="item.description.btnLink"
            target="_blank"
          >
            <button>{{ item.description.btnName }}</button>
          </a>
        </div>
      </li>
    </ul>
    <slot name="bg"></slot>
    <div class="swiper-pagination"></div>
    <template v-if="navigation">
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </template>
  </section>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "Slide",
  props: {
    banners: {
      type: Array,
      required: true,
    },
    swiperOption: {
      type: Object,
      required: true,
    },
    swiperName: {
      type: String,
      required: true,
    },
    navigation: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {};
  },
  mounted() {
    // console.log("Current Swiper instance object", this.mySwiper);
    this.mainBanner.slideTo(1, 0, false);
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
};
</script>

<style lang="less" scoped>
.b-description {
  position: absolute;

  @media (min-width: 576px) {
    &.b1 {
      top: 25%;
      left: 10%;
    }
    &.b2 {
      top: 40%;
      left: 5%;
    }
    > div {
      .mt;
      /deep/ & > p {
        .fz;
      }
    }
    h3 {
      .fz(2rem);
    }
    button {
      .py(1em);
      .px(2rem);
      .mt;
      .fz;
    }
  }
  @media (max-width: 576px) {
    &.b1 {
      top: 10%;
      left: 5%;
      right: 50%;
    }
    &.b2 {
      top: 50%;
      left: 50%;
      // right: 50%;
      transform: translate(-50%, -50%);
      h3 {
        text-align: center;
      }
    }
    max-height: 100%;
    overflow: hidden;
    > div {
      max-height: 50px;
      overflow: auto;
      /deep/ & > p {
        .fz(12px);
        .lh(16px);
      }
    }
    h3 {
      .fz(16px);
    }
    button {
      .py(4px);
      .px(10px);
      .mt(8px);
      .fz(12px);
    }
  }
  /deep/p,
  h3 {
    color: #fff;
  }
  h3 {
    .t-t;
  }
  button {
    .gd;
    .cur;
    .bg-c(@primaryColor);
    &:hover {
      .bg-c(@primaryActive);
    }
  }
}
.swiper-container {
  img {
    .wh;
  }
  /deep/.swiper-pagination {
    @media (min-width: 576px) {
      bottom: 3.5em;
    }
    @media (max-width: 576px) {
      bottom: 0.5rem;
    }
    .swiper-pagination-bullet {
      background-color: @primaryColor;
    }
  }
  /deep/.swiper-button-prev,
  .swiper-button-next {
    color: @primaryColor;
    &::after {
      .fz(5em);
    }
    &:focus {
      outline: none;
    }
  }
  a {
    display: block;
  }
  &&.fr-Banner {
    .mb(1rem);
    .wh(100%, auto);
    // @media (min-width: 576px) {
    // }
    // @media (max-width: 576px) {
    //   .wh(100%, auto);
    // }

    /deep/.swiper-pagination {
      .swiper-pagination-bullet {
        background-color: transparent;
        opacity: 1;
        .border(#fff, 2px);
        .wh(12px, 12px);
        .mx(1em);
      }
      .swiper-pagination-bullet-active {
        background-color: @primaryColor;
        border-color: transparent;
      }
    }
  }
  &&.de-s-banner {
    @media (min-width: 576px) {
      .wh(100%, auto);
    }
    > ul {
      .mb(38px);
    }
    // @media (max-width: 576px) {
    //   .wh(100%);
    // }
    a {
      .wh;
    }
    a {
      display: block;
    }
    /deep/.swiper-pagination {
      @media (min-width: 576px) {
        .wh(960px, 10px);
      }
      @media (max-width: 576px) {
        .wh(90%, 10px);
      }
      .lh(38px);
      background-color: #000;
      bottom: 1rem;
      left: 50%;
      transform: translateX(-50%);
      .flex-wrap(initial, center);
      span {
        width: 0;
        flex: 1;
        position: relative;
        .mx(0);
        &:focus {
          outline: none;
        }
      }
      .swiper-pagination-bullet {
        background-color: transparent;
        opacity: 1;
        border-radius: 0;
        height: 60%;
        .border-LR(#888);
      }
      .swiper-pagination-bullet-active {
        background-color: @primaryColor;
        // border-color: transparent;
        // .border-R;
      }
    }
    .swiper-pagination-bg {
      position: absolute;
      .wh(100%, 38px);
      z-index: 10;
      bottom: 0;
      background-color: #2e2e2e;
    }
    /deep/.swiper-button-prev,
    .swiper-button-next {
      color: @primaryColor;
      &::after {
        .fz(5em);
      }
      &:focus {
        outline: none;
      }
    }
  }
  &&.ee-banner {
    @media (min-width: 576px) {
      .mt(3rem);
      .wh(90%, auto);
      .mx(auto);
      --swiper-navigation-size: 5rem;
    }
    @media (max-width: 576px) {
      .mt(1rem);
      --swiper-navigation-size: 2.5rem;
    }
    /deep/.swiper-pagination {
      @media (min-width: 576px) {
        bottom: 3.5em;
      }
      .swiper-pagination-bullet {
        .radius(0);
        .wh(36px, 4px);
      }
    }
    .swiper-button-prev {
      left: 0;
      color: transparent;
      background: url(../../assets/img/EE/prev-icon.png) no-repeat left/60% 100%;
    }
    .swiper-button-next {
      right: 0;
      color: transparent;
      background: url(../../assets/img/EE/next-icon.png) no-repeat right/60%
        100%;
    }
  }
}
</style>
